import type { Component } from 'solid-js'
import EventForm from './EventForm'

const AdminEventsCreatePage: Component = () => {
  return <EventForm mode="create" />
}

export default AdminEventsCreatePage
